import { type DependencyList, type EffectCallback, useEffect, useRef } from "react";
import type { Primitive } from "@/lib/types";

export const useDidMount = (cb: EffectCallback) => useEffect(cb, []);

export const useDidUpdate = (cb: EffectCallback, deps?: DependencyList) => {
	const mountRef = useRef(false);

	useEffect(() => {
		if (!mountRef.current) {
			mountRef.current = true;
			return;
		}

		return cb();
		// biome-ignore lint/correctness/useExhaustiveDependencies: it is
	}, deps);
};

export const usePrevious = <T,>(value: T): T => {
	const ref = useRef<T>(value);
	useEffect(() => {
		ref.current = value;
	});
	return ref.current;
};

export const useDidChange = <T extends Primitive>(val: T, cb: (val: T, prevVal: T) => void) => {
	const prevVal = usePrevious(val);

	useEffect(() => {
		if (prevVal !== val) {
			cb(val, prevVal);
		}
	}, [prevVal, val, cb]);
};
